<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="1000">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <div>
              <h1>Envios de Emails da Fatura</h1>
            </div>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-left text-left">
            <v-btn
              elevation="2"
              class="my-5 d-flex align-left text-left"
              color="success"
              @click="isOpenValidation = true"
            >
              Enviar Email
            </v-btn>
            <v-tooltip right nudge-top="1">
              <template #activator="{ attrs, on }">
                <v-icon class="mx-2" v-bind="attrs" v-on="on" size="20"> mdi-information-outline </v-icon>
              </template>
              <span>
                Atenção! <br />
                Cada linha, da tabela abaixo, representa uma tentativa de envio de e-mail para o cliente desta fatura<br />
                bem como também a situação dessa tentativa. <br />
                A cada clique no botão "Enviar e-mail", uma nova tentativa será realizada.
              </span>
            </v-tooltip>
          </div>
          <v-data-table
            :headers="headers"
            :items="invoiceEmailHistories"
            :items-per-page="invoiceEmailHistories.length"
            :height="tableHeight"
            :loading="isEmailHistoryLoading"
            no-data-text="Nenhum email enviado"
            hide-default-footer
          >
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ transformDate(item.createdAt) }}
            </template>
            <template v-slot:[`item.emailInvoiceStatusName`]="{ item }">
              <v-chip :color="getStatusFlagColor(item.emailInvoiceStatusName)" text-color="white">
                {{ item.emailInvoiceStatusName }}
              </v-chip>
            </template>
          </v-data-table>
          <div class="d-flex align-center my-3">
            <v-pagination v-model="pageNumber" :length="totalPages" :total-visible="1"></v-pagination>
            <reload-button @click="getInvoiceEmailHistory()" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <send-email-confirm-dialog
      :isOpen.sync="isOpenValidation"
      :is-confirm-btn-loading="isSendEmailLoading"
      @confirmClick="sendEmailByInvoice()"
      title="Confirmar Envio de Email"
      body-text="Você confirma o envio de email dessa fatura?"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SendEmailConfirmDialog from '@/components/ConfirmDialog.vue';
import Base64Mixin from '@/mixins/base64.mixin';
import ReloadButton from '@/components/ReloadButton.vue';
import MessagesError from '@/components/MessagesError.vue';

export default {
  name: 'SendEmailInvoice',
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    invoiceId: null
  },
  components: {
    SendEmailConfirmDialog,
    ReloadButton,
    MessagesError
  },
  mixins: [Base64Mixin],
  data() {
    return {
      isSendEmailLoading: false,
      isEmailHistoryLoading: false,
      invoiceEmailHistories: [],
      isOpenValidation: false,
      totalPages: 1,
      pageNumber: 1,
      headers: [
        {
          value: 'createdAt',
          text: 'DATA',
          width: 200,
          sortable: true
        },
        {
          value: 'emailInvoiceStatusName',
          text: 'STATUS',
          width: 150,
          sortable: true
        },
        {
          value: 'observation',
          text: 'OBSERVAÇÃO',
          sortable: true
        }
      ],
      errors: [],
      errorsType: 'error',
      error500: null
    };
  },

  computed: {
    tableHeight() {
      const hasMoreThanTen = this.invoiceEmailHistories.length > 10;
      return hasMoreThanTen ? '450' : '';
    }
  },

  watch: {
    isOpen: {
      async handler(isOpen) {
        if (isOpen) {
          await this.getInvoiceEmailHistory();
        }
      }
    }
  },

  methods: {
    ...mapActions('InvoicesReceivableStore', ['getDetailsEmailInvoiceHistory', 'sendEmailInvoice']),

    async getInvoiceEmailHistory() {
      this.isEmailHistoryLoading = true;
      try {
        const data = await this.getDetailsEmailInvoiceHistory(this.invoiceId);
        this.invoiceEmailHistories = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isEmailHistoryLoading = false;
      }
    },

    async sendEmailByInvoice() {
      try {
        this.isSendEmailLoading = true;
        const data = await this.sendEmailInvoice(this.invoiceId);
        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(async () => {
          await this.getInvoiceEmailHistory();
        }, 2000);
        this.isOpenValidation = false;
        this.isSendEmailLoading = false;
      }
    },

    async handleSuccessFeedback() {
      this.errors = ['Envio de email solicitado com sucesso!'];
      this.errorsType = 'success';
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    },

    transformDate(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    },
    
    getStatusFlagColor(sticksName) {
      switch (sticksName) {
        case 'Enviando':
          return 'orange';
        case 'Enviado':
          return 'green';
        case 'Erro ao enviar':
          return 'red';
        default:
          return 'orange';
      }
    },

    close() {
      this.invoiceEmailHistories = [];
      this.isOpenValidation = false;
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
</style>
